import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <main data-testid="payment-cancel-page" className="max-w-lg mx-auto px-4 py-24 text-center">
      <XCircle className="w-14 h-14 text-slate-400 mx-auto mb-6" />
      <h1 className="font-heading text-3xl md:text-4xl tracking-tight mb-3">Checkout cancelled</h1>
      <p className="text-slate-600 mb-8">No charge was made. You can restart checkout anytime.</p>
      <Link to="/get-featured" data-testid="payment-cancel-retry-link" className="inline-block px-8 py-3.5 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-500 transition-colors duration-200">
        Back to Get Featured
      </Link>
    </main>
  );
}
